<template>
  <button
    class="flex"
    data-testid="modalCloseIcon"
    :aria-label="$t('Close')"
    @click="$emit('click', $event)"
  >
    <span
      class="iconify svg--close "
      :class="[iconColorClass, small ? 'text-base leading-4' : 'text-xl leading-5']"
    />
  </button>
</template>

<script lang="ts">

export default defineComponent({
  name: 'CloseButton',
  props: {
    iconColorClass: {
      type: String,
      default: 'text-EXPONDO-grey-80',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
});

</script>
